/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkoutfailederror2Inputs */

const en_checkoutfailederror2 = /** @type {(inputs: Checkoutfailederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to start checkout. Please try again later.`)
};

const de_checkoutfailederror2 = /** @type {(inputs: Checkoutfailederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout konnte nicht gestartet werden. Bitte versuche es später erneut.`)
};

/**
* | output |
* | --- |
* | "Failed to start checkout. Please try again later." |
*
* @param {Checkoutfailederror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkoutfailederror2 = /** @type {((inputs?: Checkoutfailederror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkoutfailederror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkoutfailederror2(inputs)
	return de_checkoutfailederror2(inputs)
});
export { checkoutfailederror2 as "checkoutFailedError" }